module.exports = __webpack_public_path__ + "img/item-tooltip.a445ac9f.png";